import { ArrowBack, Email, Person, Phone } from "@mui/icons-material";
import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import {
  BACK,
  SIGN_UP,
  SOMETHING_WENT_WRONG,
  SUBMIT,
  USER_ALREADY_EXIST,
  USER_EXIST_ALERT,
} from "../../constants/string";
import { useEffect, useState } from "react";
import axios from "../../network";
import LoginRedirect from "./LoginRedirect";
import { makeStyles } from "@mui/styles";
import { useNavigate } from "react-router-dom";
import { LOGIN } from "../../constants/paths";
const useStyle = makeStyles({
  button: {
    marginBottom: "16px !important",
    height: 46,
    fontSize: "1rem !important",
    borderRadius: "8px !important",
    boxShadow: "6px 6px 12px rgba(0, 0, 0, 0.1) !important",
    "&:hover": {
      boxShadow: 8,
    },
  },
  heading: {
    marginBottom: "16px !important",
    textAlign: "center",
    fontWeight: "normal ",
    color: "#333",
    fontSize: "1.6rem !important",
  },
  input: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "8px ",
  },
  inputBackground: {
    fontSize: "1.2rem !important",
    backgroundColor: "#E8F0FE",
  },
  labelColor: {
    color: "#000000 !important",
  },
});

const SignUpPage = ({ setPage, phoneNumber, setMessage }) => {
  const classes = useStyle();
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    contactNumber: "",
    sellerName: "",
    sellerEmail: "",
  });
  const navigate = useNavigate();
  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      contactNumber: phoneNumber,
    }));
  }, [phoneNumber]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    const newErrors = {};
    const { contactNumber, sellerName, sellerEmail } = formData;

    if (!/^[A-Za-z\s]+$/.test(sellerName)) {
      newErrors.sellerName = "Name should contain only letters and spaces.";
    }

    if (!/\S+@\S+\.\S+/.test(sellerEmail)) {
      newErrors.sellerEmail = "Please enter a valid email address.";
    }

    if (!/^\d{10}$/.test(contactNumber)) {
      newErrors.contactNumber =
        "Phone number should contain exactly 10 digits.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleBackPage = () => {
    setPage(1);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }

    axios
      .post("/NewUserDetails/add", { User: formData })
      .then((res) => {
        if (res.status === 200) {
          if (res.data.Reason === USER_ALREADY_EXIST) {
            const isCheck = window.confirm(USER_EXIST_ALERT);
            if (!isCheck) {
              return;
            }
            const number = formData.contactNumber;
            const dialCode = "91";
            navigate(LOGIN, { state: { number, dialCode } });
          }
          setMessage(true);
        }
      })
      .catch(() => {
        alert(SOMETHING_WENT_WRONG);
      });
  };
  return (
    <>
      <Typography variant="h4" component="h1" className={classes.heading}>
        {SIGN_UP}
      </Typography>

      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          label="Full Name"
          InputLabelProps={{
            className: classes.labelColor,
          }}
          variant="outlined"
          name="sellerName"
          value={formData.sellerName}
          onChange={handleInputChange}
          sx={{ mb: 3, fontSize: "1.6rem" }}
          required
          error={!!errors.sellerName}
          helperText={errors.sellerName}
          InputProps={{
            startAdornment: (
              <Box className={classes.input}>
                <Typography variant="h6" color="textSecondary">
                  <Person />
                </Typography>
              </Box>
            ),
            className: classes.inputBackground,
          }}
        />

        <TextField
          fullWidth
          label="Contact Number"
          InputLabelProps={{
            className: classes.labelColor,
          }}
          variant="outlined"
          name="contactNumber"
          value={formData.contactNumber}
          onChange={handleInputChange}
          sx={{ mb: 3 }}
          required
          error={!!errors.contactNumber}
          helperText={errors.contactNumber}
          type="tel"
          InputProps={{
            startAdornment: (
              <Box className={classes.input}>
                <Phone />
              </Box>
            ),
            className: classes.inputBackground,
          }}
        />

        <TextField
          fullWidth
          label="Email Address"
          variant="outlined"
          name="sellerEmail"
          InputLabelProps={{
            className: classes.labelColor,
          }}
          value={formData.sellerEmail}
          onChange={handleInputChange}
          sx={{ mb: 3 }}
          type="email"
          required
          error={!!errors.sellerEmail}
          helperText={errors.sellerEmail}
          InputProps={{
            startAdornment: (
              <Box className={classes.input}>
                <Email />
              </Box>
            ),
            className: classes.inputBackground,
          }}
        />

        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Button
              fullWidth
              variant="outlined"
              onClick={handleBackPage}
              startIcon={<ArrowBack />}
              className={classes.button}
            >
              {BACK}
            </Button>
          </Grid>

          <Grid item xs={6}>
            <Button
              fullWidth
              variant="contained"
              type="submit"
              className={classes.button}
            >
              {SUBMIT}
            </Button>
          </Grid>
        </Grid>
      </form>
      <LoginRedirect />
    </>
  );
};
export default SignUpPage;
